interface PdfFormSectionProps {
  heading: React.ReactNode;
  children: React.ReactNode;
}

export const PdfFormSection = ({ heading, children }: PdfFormSectionProps) => {
  return (
    <div>
      {heading}
      <div className="space-y-4">{children}</div>
    </div>
  );
};
